import React from "react";
import { motion } from "framer-motion";
import { FaLightbulb, FaRocket, FaPuzzlePiece, FaUsers } from "react-icons/fa";

const About: React.FC = () => {
  const qualities = [
    {
      icon: <FaLightbulb />,
      title: "Innovative",
      description: "Exploring new technologies",
    },
    {
      icon: <FaRocket />,
      title: "Efficient",
      description: "Delivering high-quality results",
    },
    {
      icon: <FaPuzzlePiece />,
      title: "Detail-Oriented",
      description: "Meticulous attention to development",
    },
    {
      icon: <FaUsers />,
      title: "Collaborative",
      description: "Thriving in team environments",
    },
  ];

  return (
    <section id="about" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-bold mb-12 text-center text-teal-400"
        >
          About Me
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="max-w-3xl mx-auto text-justify mb-12"
        >
          <p className="text-xl text-gray-300 leading-relaxed">
            As a passionate front-end developer, I blend creativity with
            technical expertise to craft engaging and intuitive user
            experiences. My approach combines cutting-edge technologies with a
            keen eye for design, resulting in web applications that are both
            functional and aesthetically pleasing.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="overflow-x-auto pb-4"
        >
          <div className="flex space-x-6 min-w-max lg:min-w-0 lg:flex-wrap lg:justify-center">
            {qualities.map((quality, index) => (
              <motion.div
                key={quality.title}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3, delay: 0.4 + index * 0.1 }}
                className="bg-gray-800 rounded-lg shadow-lg overflow-hidden flex-shrink-0 w-64 lg:w-56 xl:w-64"
              >
                <div className="p-6 flex flex-col items-center text-center">
                  <div className="inline-block p-3 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 text-gray-900 mb-4">
                    {React.cloneElement(quality.icon, { className: "w-6 h-6" })}
                  </div>
                  <h3 className="text-xl font-semibold mb-2 text-teal-400">
                    {quality.title}
                  </h3>
                  <p className="text-gray-300">{quality.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
